import Cookies from 'js-cookie';

export default {
  isAuthenticated() {
    return this.getToken() !== undefined;
  },

  authenticate(credentials) {
    return this.token(credentials).then((response) => {
      Cookies.set('token', response.data.access_token, { expires: 7 });
      return response;
    }).catch((error) => {
      this.logout();
      throw error;
    });
  },

  logout() {
    Cookies.remove('token');
    Cookies.remove('cart');
  },

  getToken() {
    return Cookies.get('token');
  },

  token(payload) {
    return api.post('auth/token', payload);
  },

  refresh(payload) {
    return api.post('auth/refresh', payload);
  },

  forgot(payload) {
    return api.post('password/email', payload);
  },

  reset(payload) {
    return api.post('password/reset', payload);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/auth.js